import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { PortfolioPricingApplicationRow } from "@/lib/portfolioPricing";

export const usePortfolioPricingApplication = (
  userId?: string | null,
  enabled = true,
) =>
  useQuery<PortfolioPricingApplicationRow | null>({
    queryKey: ["portfolio-pricing-application", userId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("portfolio_pricing_applications")
        .select("*")
        .eq("user_id", userId!)
        .order("submitted_at", { ascending: false })
        .limit(1)
        .maybeSingle();

      if (error) throw error;
      return data ?? null;
    },
    enabled: Boolean(userId) && enabled,
  });

